import { Col, Form, Input, InputProps, Row, Space } from 'antd';
import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput from 'react-phone-number-input/min';
import 'react-phone-number-input/style.css';
import { useCompanyPhoneCountryAndPlaceholder } from '../hooks/usePhoneCountryAndPlaceholder';
import LabelWrapper from './LabelWrapper';

enum NameMap {
    phone = 'phone'
}

// * use with antd Input component
interface GrispiInputProps extends InputProps {
    name?: string;
    label?: string;
    control?: any;
    rightActionText?: string;
    onClickRightAction?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    tooltip?: string;
    width?: string | number;
    textArea?: boolean;
    validateStatus?: boolean;
    help?: string;
}

const GrispiInput = ({
    name,
    label,
    control,
    rightActionText,
    onClickRightAction,
    tooltip,
    width = '100%',
    textArea = false,
    validateStatus = false,
    help = null,
    ...antdProps
}: GrispiInputProps | any): JSX.Element => {
    const labelWrapperProps = { label, rightActionText, onClickRightAction, tooltip };
    // TODO cagri: should enchance the Component structure
    const isPasswordInput = name === 'password' || name === 'passwordConfirm';
    const isPhoneInput = name === NameMap.phone;
    // const organizationCreateProp = name ==='organizationName' ?
    const { phoneCountry, phonePlaceHolder } = useCompanyPhoneCountryAndPlaceholder();
    return (
        <Space direction="vertical" size={2} style={{ width }}>
            <LabelWrapper {...labelWrapperProps} />
            <Row>
                <Col flex={1}>
                    {control ? (
                        <Controller
                            control={control}
                            name={name}
                            render={({ field, fieldState: { error } }) => {
                                return (
                                    <Form.Item
                                        validateStatus={error && 'error'}
                                        help={error?.message}
                                        style={{ marginBottom: 5 }}
                                    >
                                        {textArea ? (
                                            <Input.TextArea {...field} {...antdProps} />
                                        ) : isPasswordInput ? (
                                            <Input.Password {...field} {...antdProps} />
                                        ) : isPhoneInput ? (
                                            <PhoneInput
                                                defaultCountry={phoneCountry}
                                                placeholder={phonePlaceHolder}
                                                value={field.value}
                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                                numberInputProps={{
                                                    className: 'grispi-phone-input'
                                                }}
                                                {...antdProps}
                                            />
                                        ) : (
                                            <Input {...field} {...antdProps} />
                                        )}
                                    </Form.Item>
                                );
                            }}
                        />
                    ) : (
                        <Form.Item
                            style={{ marginBottom: 5 }}
                            validateStatus={validateStatus && 'error'}
                            help={validateStatus && help}
                        >
                            {textArea ? <Input.TextArea {...antdProps} /> : <Input {...antdProps} />}
                        </Form.Item>
                    )}
                </Col>
            </Row>
        </Space>
    );
};

export default memo(GrispiInput);
